import React from "react";
import PropTypes from "prop-types";
import { Modal, Typography } from "components";
import { IoMdClose } from "react-icons/io";

import successImg from "assets/images/success-image.png";

const NotificationModal = ({
  showModal,
  onClose,
  bodyText,
  headerText,
  image,
}) => (
  <Modal showModal={showModal} onClose={onClose}>
    <div className="my-4">
      <div className="d-flex justify-content-end">
        <IoMdClose className="cursor-pointer" onClick={onClose} />
      </div>
      <div className="text-center mt-2 mx-auto" style={{ width: "90%" }}>
        {image ? image : <img src={successImg} alt="" width="120" />}
        <div style={{ marginTop: "2rem" }}>
          <Typography
            variant="subtitle3"
            component="h5"
            state="primary"
            className="mt-4"
          >
            {headerText}
          </Typography>
          <Typography variant="body3" state="primary" className="mt-3 mb-4">
            {bodyText}
          </Typography>
        </div>
      </div>
    </div>
  </Modal>
);

NotificationModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  self: PropTypes.bool,
  onClose: PropTypes.func,
  bodyText: PropTypes.string,
  headerText: PropTypes.string,
  image: PropTypes.node,
};

export default NotificationModal;
